module.exports = __webpack_public_path__ + "media/images/lilica-b71cdb3bdb967ff0ec4361d8d9050f57.jpg";